import AifPmsActions from "@redux/feature/Markets/InvestmentManagement/actions";
import PaymentActions from "@redux/feature/Markets/InvestmentManagement/actions/PaymentAction";
import PurchaseActions from "@redux/feature/Markets/InvestmentManagement/actions/PurchaseAction";
import DraftActions from "@redux/feature/Markets/InvestmentManagement/actions/DraftAction";
import GlobalActions from "@redux/feature/Markets/InvestmentManagement/actions/GlobalAction";
import OrderBookActions from "@redux/feature/Markets/InvestmentManagement/actions/OrderBookAction";
import LeadServiceActions from "@redux/feature/Markets/InvestmentManagement/actions/LeadServiceAction";
import QualityCheckActions from "@redux/feature/Markets/InvestmentManagement/actions/QualityCheckAction";
export default (function () {
    return {
        aifPms: {
            aifPmsActions: new AifPmsActions(),
        },
        payment: new PaymentActions(),
        purchase: new PurchaseActions(),
        draft: new DraftActions(),
        global: new GlobalActions(),
        orderBook: new OrderBookActions(),
        leadservice: new LeadServiceActions(),
        qualityCheck: new QualityCheckActions(),
    };
});
